import React from 'react';

function PadlockSvg({ className }) {
  return (
    <svg
      className={className}
      width="43"
      height="47"
      viewBox="0 0 43 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Group 93">
        <path
          id="Vector"
          d="M35.8889 21.5098H7.11111C4.84061 21.5098 3 23.3504 3 25.6209V40.0098C3 42.2803 4.84061 44.1209 7.11111 44.1209H35.8889C38.1594 44.1209 40 42.2803 40 40.0098V25.6209C40 23.3504 38.1594 21.5098 35.8889 21.5098Z"
          stroke="#F7F6F6"
          strokeWidth="4.11111"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M11.2222 21.5104V13.2881C11.2196 10.7393 12.1642 8.28052 13.8726 6.389C15.5809 4.49748 17.9312 3.30821 20.467 3.05206C23.0029 2.79591 25.5435 3.49115 27.5956 5.00283C29.6478 6.51451 31.065 8.73476 31.5722 11.2326"
          stroke="#F7F6F6"
          strokeWidth="4.11111"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default PadlockSvg;
